import React from 'react';
import { Route, Routes } from "react-router-dom";

import Main from './components/Main';
import Contact from './components/Contact';
import NoPage from './components/NoPage';
import SinglePage from './components/SinglePage';
import Layout from '../src/components/Layout';


function App() {
  return (
    <>
      <Routes>
        <Route path='/' element={<Layout/>}>
          <Route path='/' element={<Main/>}/>
          <Route path='news/:id' element={<SinglePage/>}/>
          <Route path='contact' element={<Contact/>}/>
          {/* 404 rounte */}
          <Route path='*' element={<NoPage/>}/>
        </Route>  
      </Routes>
    </>
  );
}

export default App;
